import InternalUserView from './InternalUserView';

export default InternalUserView;
